import { render } from "./InitialPassword.vue?vue&type=template&id=ebdbe270&scoped=true"
import script from "./InitialPassword.vue?vue&type=script&lang=js"
export * from "./InitialPassword.vue?vue&type=script&lang=js"

import "./InitialPassword.vue?vue&type=style&index=0&id=ebdbe270&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdbe270"]])

export default __exports__